


















































// vendor
import { computed, defineComponent, PropType, ref, set } from "@vue/composition-api";
// project
import * as DOMUtils from "@/utils/dom";
import * as AppModal from "@/AppModal";
// import { useRouteCustomParams } from "@/hooks/useRouteCustomParams";
import { Study } from "@/psychlab/types";
// import { Confirm, IConfirmModal } from "@/components.generic/utility-modal";
import * as StudyAPI from "@/services/api/studies";


const STUDY_OPEN_MESSAGE = "This will start the study and allow more participants to join. Are you sure?";
const STUDY_CLOSE_MESSAGE = "This will end the study and prevent more participants from joining. Are you sure?";


export default defineComponent({
	props: {
		study: {
			type: Object as PropType<Study>,
			required:true,
		},
	},
	// components:{
	// 	Confirm,
	// },
	setup(props, ctx) {

		const toggling = ref(false);
		
		// const { studyId } = useRouteCustomParams(ctx);

		const studyId = computed(() => {
			const r = ctx.root.$route;
			return r.params["studyId"] || r.params["groupId"];
		});

		// const confirmModal = ref<IConfirmModal>();

		const toggleEnabled = async () => {
			
			// if(!confirmModal.value){ return; }

			if (toggling.value) { return; }
			const variant = (props.study.enabled ? "danger" : "info");

			const title = (props.study.enabled ? "Close Study" : "Open Study");

			const description = props.study.enabled ? STUDY_CLOSE_MESSAGE : STUDY_OPEN_MESSAGE;

			AppModal.confirm({
				title,
				variant,
				okText:"I Understand",
				description,
				cancelText:"Cancel",

			}, async () => {
				toggling.value = true;
				const v = !props.study.enabled;
				try {
					if (studyId.value) {
						await StudyAPI.setStudyEnabled(studyId.value, v);
						set(props.study, "enabled", v);
					}
				} catch (err) {
					console.log(err);
				}
				toggling.value = false;
			});
		};

		return {
			toggleEnabled,
		};
	},
});
